import { Button } from "@mui/material";
import { styled } from "@mui/styles";


export const ButtonContainer = styled(Button)(() => ({
	cursor: "pointer",
	padding: "0.31rem 1rem",
	borderRadius: 20,
	backgroundColor: "#638dff",
	color: "#FFFFFF",
	fontFamily: 'Roboto, sans-serif',
	fontSize: "14px",
	boxShadow: "none",
	"&:hover": {
		backgroundColor: "#4c71d6",
	},
	"&:focus": {
		boxShadow: "0 0 6px 0 #638dff !important",
	},
	"&:disabled": {
		backgroundColor: "#aeb8d6",
		color: "#e8ecf8",
	},
}));